import ContainerModalActions from "../../../../components/Containers/ContainerModalActions";
import {
  BUTTON_GO_BACK,
  MODAL_PREVIEW_OPTIMIZATIONS_TITLE,
  BUTTON_MARK_AS_DONE,
  BUTTON_CREATE_CUSTOM_AUDIENCE,
} from "../../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../../lib/i18next";
import ModalBasicLayout from "../../../../components/Modal/ModalBasicLayout";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import DialogActions from "@mui/material/DialogActions";
import { useFormContext } from "react-hook-form";
import { useDispatchApp } from "../../../../lib/redux";
import { startSetRecommendedActionIsApplied } from "../../../../actions/adsCampaigns";
import { RECOMMENDED_ACTION_CATEGORIES } from "../../../../utils/constants";
import { openLink } from "../../../../utils/string";
import { getCreateCustomAudienceLink } from "../../../../actions/getters";

const ModalViewAction = ({
  modalOpen,
  platform,
  action,
  actionIndex,
  onCloseModal = () => {},
}) => {
  const { t } = useTranslationApp();
  const { campaignID, setValue, getValues } = useFormContext();
  const dispatch = useDispatchApp();

  const platformData = getValues(`platformsData.${platform}`);
  const adAccountID = platformData?.adAccountID;

  const onApplyOptimizations = async () => {
    const response = await dispatch(
      startSetRecommendedActionIsApplied({
        campaignID,
        platform,
        actionIndex,
        isApplied: true,
      })
    );
    if (!response.ok) return;

    setValue(
      `platformsData.${platform}.recommendedActions.[${actionIndex}].isApplied`,
      true
    );

    onCloseModal();

    return;
  };

  const getRecommendedActionConfiguration = () => {
    switch (action.category) {
      case RECOMMENDED_ACTION_CATEGORIES.CUSTOM_AUDIENCE:
        return {
          onClick: () => {
            const link = dispatch(
              getCreateCustomAudienceLink(platform, adAccountID)
            );

            if (link) {
              openLink(link);
            }
          },
          text: t(BUTTON_CREATE_CUSTOM_AUDIENCE),
          showButton: true,
        };

      default:
        return {
          showButton: false,
        };
    }
  };

  const { onClick, text, showButton } = getRecommendedActionConfiguration();

  return (
    <ModalBasicLayout
      modalOpen={modalOpen}
      onCloseModal={onCloseModal}
      fullWidth={true}
      scroll="paper"
      maxWidth="sm"
      title={t(MODAL_PREVIEW_OPTIMIZATIONS_TITLE)}
    >
      <Box sx={{ mt: 2 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
          }}
        >
          <Typography variant="body1" sx={{ fontWeight: 600 }}>
            {action.title}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              maxHeight: 250,
              pr: 1,
              mb: 2,
            }}
          >
            {action.action}
          </Typography>
        </Box>
      </Box>
      <DialogActions sx={{ p: 0 }}>
        <ContainerModalActions
          hasPadding={true}
          propsSecondaryButton={{
            showButton: true,
            onClick: onCloseModal,
            text: BUTTON_GO_BACK,
          }}
          propsTertiaryButton={{
            showButton,
            text,
            onClick,
          }}
          propsPrimaryButton={{
            showButton: true,
            text: BUTTON_MARK_AS_DONE,
            type: "submit",
            onClick: () => {
              onApplyOptimizations();
              onCloseModal();
            },
          }}
          sxButtonSecondary={{
            px: "10px",
            fontSize: 14,
          }}
          sxButtonTertiary={{
            px: "10px",
            fontSize: 14,
          }}
          sxButtonPrimary={{
            px: 5,
            fontSize: 14,
          }}
        />
      </DialogActions>
    </ModalBasicLayout>
  );
};

export default ModalViewAction;
